/**
 * The snap guides, with what they mean written on them.
 *
 * §6.3 is specific: *centre*, *aligned to logo*, *3 mm from trim* - not a bare
 * pink line. A line alone tells a customer that something happened; the label
 * tells them what, which is the difference between a tool that feels precise
 * and one that feels like it is grabbing at things.
 *
 * Blue, not the accent. The accent means selection, and a guide is not one.
 */

import { Group, Label, Line, Tag, Text } from 'react-konva';
import { useEditor } from '../state/store';
import { mmToPx } from '../model/units';

const GUIDE = '#0b84ff';

export function Guides({ zoom }: { zoom: number }) {
  const guides = useEditor((s) => s.guides);

  if (guides.length === 0) return null;

  return (
    <Group listening={false}>
      {guides.map((guide, index) => {
        const at = mmToPx(guide.at, zoom);
        const from = mmToPx(guide.from, zoom);
        const to = mmToPx(guide.to, zoom);

        // The line runs a little past what it connects, so it reads as a
        // measurement rather than as an edge of something.
        const overhang = 12;

        const points =
          guide.axis === 'x'
            ? [at, from - overhang, at, to + overhang]
            : [from - overhang, at, to + overhang, at];

        return (
          <Group key={`${guide.axis}-${guide.at}-${index}`}>
            <Line points={points} stroke={GUIDE} strokeWidth={1} strokeScaleEnabled={false} dash={[4, 3]} />

            <Label
              x={guide.axis === 'x' ? at + 6 : from - overhang}
              y={guide.axis === 'x' ? from - overhang : at - 20}
            >
              <Tag fill={GUIDE} cornerRadius={3} />
              <Text
                text={guide.label}
                fill="#ffffff"
                fontSize={11}
                fontFamily="system-ui, sans-serif"
                padding={4}
              />
            </Label>
          </Group>
        );
      })}
    </Group>
  );
}
